export const errors = {
    required: 'State required',
    minLength: 'State abbreviations only please, e.g. MA',
    maxLength: 'State abbreviations only please, e.g. MA',
    invalid: 'CAPITAL Letters only please, e.g. MA'
};
